import { create } from "zustand";
import actionWebInvoke from "../utils/actionWebInvoke";
import actions from "../config.json";

export const usePassionsStore = create((set, get) => ({
  passions: null,
  selectedPassions: [], // Track currently selected passions for reactive UI
  loading: false,
  error: null,
  lastFetchedAcid: null,

  setPassions: (passions) => {
    set({ passions, loading: false, error: null });
  },

  // Set selected passions (for reactive UI updates)
  setSelectedPassions: (passions) => {
    const newPassions = Array.isArray(passions) ? passions : [];
    set({ selectedPassions: newPassions });
  },

  // Toggle a single passion selection
  togglePassion: (passionId) => {
    const { selectedPassions } = get();
    const isSelected = selectedPassions.includes(passionId);
    const newPassions = isSelected
      ? selectedPassions.filter((p) => p !== passionId)
      : [...selectedPassions, passionId];
    set({ selectedPassions: newPassions });
  },

  // Add a passion to selection
  addPassion: (passionId) => {
    const { selectedPassions } = get();
    if (!selectedPassions.includes(passionId)) {
      set({ selectedPassions: [...selectedPassions, passionId] });
    }
  },

  // Remove a passion from selection
  removePassion: (passionId) => {
    const { selectedPassions } = get();
    set({ selectedPassions: selectedPassions.filter((p) => p !== passionId) });
  },

  // Check if a passion is selected
  isPassionSelected: (passionId) => {
    return get().selectedPassions.includes(passionId);
  },

  // Get the primary passion (first selected or default)
  getPrimaryPassion: () => {
    const { selectedPassions } = get();
    return selectedPassions.length > 0 ? selectedPassions[0] : "golf";
  },

  setLoading: (loading) => set({ loading }),

  setError: (error) => {
    console.error("passions error:", error);
    set({ error, loading: false });
  },

  fetchPassions: async (acid) => {
    const { lastFetchedAcid } = get();

    // Skip if already fetching for the same acid
    if (lastFetchedAcid === acid && get().passions) {
      return;
    }

    if (!acid) {
      console.warn("Cannot fetch passions: acid is not available");
      return;
    }

    try {
      set({ loading: true, error: null, lastFetchedAcid: acid });

      actionWebInvoke(
        actions["marriott-passions-v3/get-passions"],
        {},
        { acid },
      ).then((response) => {
        get().setPassions(response);
      });
    } catch (error) {
      get().setError(error.message);
    }
  },

  clearPassions: () =>
    set({ passions: null, selectedPassions: [], error: null, lastFetchedAcid: null }),
}));
